
/**
 * SAT Reading & Writing Domain Lessons
 */
export const SAT_DOMAIN_LESSONS_RW = {
    craftAndStructure: [
        "ACT&SATReadingPassagesOverview",
        "SinglePassages",
        "DualPassages",
    ],
    informationAndIdeas: [
        "SinglePassagesWithFigures",
    ],
    expressionOfIdeas: [
        "Usage&Mechanics",
        "Transitions",
    ],
    standardEnglishConventions: [
        "AdjectivesAdverbs&Idioms",
        "Agreement",
        "Apostrophes",
        "BasicsButEssentials",
        "ModifyingPhrases",
        "OtherToughOnes",
        "Parallelism",
        "Pronouns",
        "Punctuation",
        "Verbs",
    ],
}

/**
 * SAT Math Domain Lessons
 */
export const SAT_DOMAIN_LESSONS_MATH = {
    algebra: [
        "AbsoluteValue&Inequalities",
        "AlgebraStrategies",
        "ArithmeticSequences",
        "CombiningUnits",
        "f(x)&CompositeFunctions",
        "Graphing&SolvingLines",
        "LinearSystemsWordProblems",
        "SolvingMultipleLinearSystems",
    ],
    advancedMath: [
        "CombiningFractions",
        "ExponentRules",
        "Factoring",
        "FOIL",
        "MainGraphs&Transformations",
        "SimplifyingRadicals",
        "SolvingQuadraticEquations",
        "SolvingRadicals&Exponents"
    ],
    geometryAndTrigonometry: [
        "2DShapes:Part1:",
        "2DShapes:Part2:",
        "2DShapes:Part3:",
        "3DShapes:Part1",
        "3DShapes:Part2",
        "Circles:ArcLength&SectorArea",
        "Circles:Circumference&Area",
        "Circles:EquationOfACircle",
        "GeometryFundamentals:Angles&CoordinatePlane",
        "SixTrigFunctions",
        "Triangles:3rdSideRule&SimilarTriangles",
        "Triangles:Basics&Area",
        "Triangles:PythagoreanTheorem",
        "Triangles:SOHCAHTOA",
        "Triangles:SpecialRightTriangles",
        "UnitCircle",
    ],
    problemSolvingAndDataAnalysis:  [
        "AlgebraFundamentals:KeyDefinitions",
        "Distance&AverageSpeed",
        "Distance&MidpointFormulas",
        "Figures&Tables",
        "MeanMedian&Mode",
        "Percents",
        "Probability",
        "Rare&Random",
        "Ratios",
    ],

}

export const SAT_DOMAIN_LESSONS_MATH_AND_RW = {
    ...SAT_DOMAIN_LESSONS_MATH,
    ...SAT_DOMAIN_LESSONS_RW,
}

/**
 * SAT Subcategory Names
 */
export const SAT_SUBCATEGORY_NAMES = {
    // Reading & Writing
    craftAndStructure: "Craft and Structure",
    informationAndIdeas: "Information and Ideas",
    expressionOfIdeas: "Expression of Ideas",
    standardEnglishConventions: "Standard English Conventions",
    
    // Math
    algebra: "Algebra",
    advancedMath: "Advanced Math",
    geometryAndTrigonometry: "Geometry and Trigonometry",
    problemSolvingAndDataAnalysis: "Problem Solving and Data Analysis",
}

/**
 * Populates the subcategories in the questions
 * @param questions 
 * @returns 
 */
export function populateSubcategoriesForSATQuestions(questions) {
    let keys = Object.keys(SAT_DOMAIN_LESSONS_MATH_AND_RW)
    questions.forEach((question) => {
        let { lessonId } = question
        keys.forEach((key) => {
            let subcategories = SAT_DOMAIN_LESSONS_MATH_AND_RW[key]
            if (subcategories.includes(lessonId)) {
                question.subcategory = SAT_SUBCATEGORY_NAMES[key]
            }
        })
    })
    return questions
}

// OT: Needed?
export function findLessonsMetaDataFromQuestions(questions) {
    let lessons = new Map()
    populateSubcategoriesForSATQuestions(questions)
    questions.forEach((question) => {
        let { lessonId, lessonName, subcategory } = question
        let lesson = lessons[lessonId]

        if (!lesson) {
            let lesson = { lessonId, lessonName, subcategory }
            lessons[lessonId] = lesson
        }
    })
    return Object.values(lessons)
}
